import services from './services';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import areaSelect from 'area-select';
export default {
    mixins: [services],
    components: {
        areaSelect
    },
    data() {
        return {
            addAddressVisible: false,
            loading: false,
            AddressList: [],
            SchoolId: 0,
            Address: [{
                Provinces_Id: "",
                City_Id: "",
                Area_Id: ""
            }],
            addressObject: {},
            form: this.initConsignee() //新增收货信息
        }
    },
    methods: {
        initArea() {
            return cloneDeep({
                Provinces_Id: "",
                City_Id: "",
                Area_Id: ""
            });
        },
        initConsignee() {
            return cloneDeep({
                "Id": 0,
                "SchoolId": 0,
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeProvince": 0,
                "ConsigneeCity": 0,
                "ConsigneeArea": 0,
                "ConsigneeAdress": "",
                "IsDefault": true
            });
        },
        //修改地址
        addAddress() {
            let address = this.$refs.area.validate();
            if (!!address) {
                this.form.ConsigneeProvince = address.Provinces_Id;
                this.form.ConsigneeCity = address.City_Id;
                this.form.ConsigneeArea = address.Area_Id;
                this.form.ConsigneeAreaName = address.areaName
                this.form.ConsigneeCityName = address.cityName
                this.form.ConsigneeProvinceName = address.provName
            }
            this.form.SchoolId = this.SchoolId
            // 判断
            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "详细地址",
                    value: this.form.ConsigneeAdress,
                    required: true,
                }, {
                    name: "联系人",
                    value: this.form.Consignee,
                    required: true,
                }, {
                    name: "联系电话",
                    value: this.form.ConsigneeTel,
                    phone: true,
                }]
            });

            if (!flag) {
                return;
            }
            console.log(this.form)
            this.addSchoolConsigneeList()



        },
        show(options) {
            console.log(options.Id)
            this.addAddressVisible = true;
            this.SchoolId = options.SchoolId
            this.form.Id = options.Id
            //this.getSchoolConsigneeList(this.SchoolId)
            this.form.Consignee = options.address.Consignee
            this.form.ConsigneeTel = options.address.ConsigneeTel
            this.form.ConsigneeAdress = options.address.ConsigneeAddress
            this.form.ConsigneeProvince = options.address.ConsigneeProvId;
            this.form.ConsigneeCity = options.address.ConsigneeCityId;
            this.form.ConsigneeArea = options.address.ConsigneeAreaId;
            this.$nextTick(() => {
                this.Address = []
                this.Address.Provinces_Id = options.address.ConsigneeProvId;
                this.Address.City_Id = options.address.ConsigneeCityId;
                this.Address.Area_Id = options.address.ConsigneeAreaId;

            })


        },

    },
    computed: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/AddressDialog/vm.js